import React from 'react';
import { Camera, Image, Loader2 } from 'lucide-react';

interface ActionButtonsProps {
  showCamera: boolean;
  loading: boolean;
  selectedTask: string;
  photosCount: number;
  onChooseFiles: () => void;
  onUseCamera: () => void;
  onStopCamera: () => void;
  onUpload: () => void;
}

export function ActionButtons({
  showCamera,
  loading,
  selectedTask,
  photosCount,
  onChooseFiles,
  onUseCamera,
  onStopCamera,
  onUpload
}: ActionButtonsProps) {
  return (
    <div className="space-y-4">
      {!showCamera ? (
        <div className="flex flex-col sm:flex-row gap-3 w-full">
          <button
            onClick={onChooseFiles}
            disabled={loading || !selectedTask}
            className="btn-secondary w-full sm:w-auto"
          >
            <Image className="h-4 w-4" />
            Choose Files
          </button>
          <button
            onClick={onUseCamera}
            disabled={loading || !selectedTask}
            className="btn-primary w-full sm:w-auto"
          >
            <Camera className="h-4 w-4" />
            Use Camera
          </button>
        </div>
      ) : (
        <button
          onClick={onStopCamera}
          className="btn-secondary"
        >
          Stop Camera
        </button>
      )}

      {photosCount > 0 && (
        <button
          onClick={onUpload}
          disabled={loading}
          className="btn-primary w-full sm:w-auto"
        >
          {loading ? (
            <>
              <Loader2 className="h-4 w-4 animate-spin" />
              Uploading...
            </>
          ) : (
            <>
              <Camera className="h-4 w-4" />
              Upload {photosCount} Photo{photosCount !== 1 ? 's' : ''}
            </>
          )}
        </button>
      )}
    </div>
  );
}